import { get, post } from './fetcher';
import { API_ENDPOINTS } from '../config/api-config';

export const getRankerDanjiList = async (params = {}) => {
  const {
    bjdCode = '',
    bjdCodes = [],
    keyword = '',
    pageNumber = 1,
    page = null,
    pageSize = 20,
  } = params;

  const bjdCodesCsv = Array.isArray(bjdCodes) ? bjdCodes.join(',') : '';

  return get(API_ENDPOINTS.SYSTEM.RANKER_DANJI_LIST, {
    bjdCode,
    bjdCodes: bjdCodesCsv,
    keyword,
    pageNumber,
    page: page ?? pageSize,
    pageSize,
  });
};

export const getRankerDanjiCount = async (params = {}) => {
  const {
    bjdCode = '',
    bjdCodes = [],
  } = params;

  return post(API_ENDPOINTS.SYSTEM.RANKER_DANJI_COUNT, {
    bjdCode,
    bjdCodes: Array.isArray(bjdCodes) ? bjdCodes : [],
  });
};

export const getRankerFixList = async (params = {}) => {
  const {
    bjdCode = '',
    bjdCodes = [],
    keyword = '',
    isFavorite = false,
    favoriteGroupId = null,
    groupAverage = false,
    highRankerOnly = false,
    gubunFilters = [],
    groupByLevels = [],
    regionAvgLevels = [],
    regionAvgOnly = false,
    useDefaultColumns = true,
    orderBy = null,
    offset = 0,
    pageSize = 100,
    // 필터 파라미터
    tradePriceMin = null,
    tradePriceMax = null,
    investPriceMin = null,
    investPriceMax = null,
    investRealInvestPriceMin = null,
    investRealInvestPriceMax = null,
    complexMinTradePriceMin = null,
    complexMinTradePriceMax = null,
    complexMaxTradePriceMin = null,
    complexMaxTradePriceMax = null,
    leasePriceMin = null,
    leasePriceMax = null,
    complexMinLeasePriceMin = null,
    complexMinLeasePriceMax = null,
    complexMaxLeasePriceMin = null,
    complexMaxLeasePriceMax = null,
    avgSaleRealPriceMin = null,
    avgSaleRealPriceMax = null,
    avgLeaseRealPriceMin = null,
    avgLeaseRealPriceMax = null,
    tradeArticleCountMin = null,
    tradeArticleCountMax = null,
    leaseArticleCountMin = null,
    leaseArticleCountMax = null,
    leasePriceRateMin = null,
    leasePriceRateMax = null,
    riseRateMin = null,
    riseRateMax = null,
    risePriceMin = null,
    risePriceMax = null,
    supply3YearsMin = null,
    supply3YearsMax = null,
    useApproveAgeMin = null,
    useApproveAgeMax = null,
    areaMin = null,
    areaMax = null,
    householdMin = null,
    householdMax = null,
    sigunguGrades = null,
    dongGrades = null,
    houseStructure = null,
    // 변동율 필터 파라미터
    goHyunRateMin = null,
    goHyunRateMax = null,
    jeokHyunRateMin = null,
    jeokHyunRateMax = null,
    goJeoRateMin = null,
    goJeoRateMax = null,
    jeoHyunRateMin = null,
    jeoHyunRateMax = null,
    changeGapMin = null,
    changeGapMax = null,
    // 기준가 필터 파라미터
    pastTopPriceMin = null,
    pastTopPriceMax = null,
    prevHighPriceMin = null,
    prevHighPriceMax = null,
    properHighPriceMin = null,
    properHighPriceMax = null,
    prevLowPriceMin = null,
    prevLowPriceMax = null,
    // 타겟가 필터 파라미터
    targetPriceMin = null,
    targetPriceMax = null,
    // 안전마진(개인별) — 여유매수/매도가 재계산용
    buyMargin = null,
    sellMargin = null,
    // 세금(취득세) 개인화 — 주택수/생애최초
    houseCount = null,
    firstTime = null,
  } = params;

  const bjdCodesCsv = Array.isArray(bjdCodes) ? bjdCodes.join(',') : '';
  const gubunFiltersCsv = Array.isArray(gubunFilters) ? gubunFilters.join(',') : '';
  const groupByLevelsCsv = Array.isArray(groupByLevels) ? groupByLevels.join(',') : '';
  const regionAvgLevelsCsv = Array.isArray(regionAvgLevels) ? regionAvgLevels.join(',') : '';
  const orderByJson = orderBy && Array.isArray(orderBy) && orderBy.length > 0 ? JSON.stringify(orderBy) : '';

  const queryParams = {
    bjdCode,
    bjdCodes: bjdCodesCsv,
    keyword,
    isFavorite,
    highRankerOnly,
    gubunFilters: gubunFiltersCsv,
    groupByLevels: groupByLevelsCsv,
    regionAvgLevels: regionAvgLevelsCsv,
    useDefaultColumns,
    orderBy: orderByJson,
    offset,
    pageSize,
  };

  // favoriteGroupId가 유효한 값일 때만 추가
  if (favoriteGroupId && favoriteGroupId > 0) {
    queryParams.favoriteGroupId = favoriteGroupId;
  }
  // 즐겨찾기 그룹평균 토글
  if (groupAverage) {
    queryParams.groupAverage = true;
  }
  // 단지제외(지역평균만)
  if (regionAvgOnly) {
    queryParams.regionAvgOnly = true;
  }

  // 필터 파라미터 추가 (값이 있을 때만)
  if (tradePriceMin != null) queryParams.tradePriceMin = tradePriceMin;
  if (tradePriceMax != null) queryParams.tradePriceMax = tradePriceMax;
  if (investPriceMin != null) queryParams.investPriceMin = investPriceMin;
  if (investPriceMax != null) queryParams.investPriceMax = investPriceMax;
  if (investRealInvestPriceMin != null) queryParams.investRealInvestPriceMin = investRealInvestPriceMin;
  if (investRealInvestPriceMax != null) queryParams.investRealInvestPriceMax = investRealInvestPriceMax;
  if (complexMinTradePriceMin != null) queryParams.complexMinTradePriceMin = complexMinTradePriceMin;
  if (complexMinTradePriceMax != null) queryParams.complexMinTradePriceMax = complexMinTradePriceMax;
  if (complexMaxTradePriceMin != null) queryParams.complexMaxTradePriceMin = complexMaxTradePriceMin;
  if (complexMaxTradePriceMax != null) queryParams.complexMaxTradePriceMax = complexMaxTradePriceMax;
  if (leasePriceMin != null) queryParams.leasePriceMin = leasePriceMin;
  if (leasePriceMax != null) queryParams.leasePriceMax = leasePriceMax;
  if (complexMinLeasePriceMin != null) queryParams.complexMinLeasePriceMin = complexMinLeasePriceMin;
  if (complexMinLeasePriceMax != null) queryParams.complexMinLeasePriceMax = complexMinLeasePriceMax;
  if (complexMaxLeasePriceMin != null) queryParams.complexMaxLeasePriceMin = complexMaxLeasePriceMin;
  if (complexMaxLeasePriceMax != null) queryParams.complexMaxLeasePriceMax = complexMaxLeasePriceMax;
  if (avgSaleRealPriceMin != null) queryParams.avgSaleRealPriceMin = avgSaleRealPriceMin;
  if (avgSaleRealPriceMax != null) queryParams.avgSaleRealPriceMax = avgSaleRealPriceMax;
  if (avgLeaseRealPriceMin != null) queryParams.avgLeaseRealPriceMin = avgLeaseRealPriceMin;
  if (avgLeaseRealPriceMax != null) queryParams.avgLeaseRealPriceMax = avgLeaseRealPriceMax;
  if (tradeArticleCountMin != null) queryParams.tradeArticleCountMin = tradeArticleCountMin;
  if (tradeArticleCountMax != null) queryParams.tradeArticleCountMax = tradeArticleCountMax;
  if (leaseArticleCountMin != null) queryParams.leaseArticleCountMin = leaseArticleCountMin;
  if (leaseArticleCountMax != null) queryParams.leaseArticleCountMax = leaseArticleCountMax;
  if (leasePriceRateMin != null) queryParams.leasePriceRateMin = leasePriceRateMin;
  if (leasePriceRateMax != null) queryParams.leasePriceRateMax = leasePriceRateMax;
  if (riseRateMin != null) queryParams.riseRateMin = riseRateMin;
  if (riseRateMax != null) queryParams.riseRateMax = riseRateMax;
  if (risePriceMin != null) queryParams.risePriceMin = risePriceMin;
  if (risePriceMax != null) queryParams.risePriceMax = risePriceMax;
  if (supply3YearsMin != null) queryParams.supply3YearsMin = supply3YearsMin;
  if (supply3YearsMax != null) queryParams.supply3YearsMax = supply3YearsMax;
  if (useApproveAgeMin != null) queryParams.useApproveAgeMin = useApproveAgeMin;
  if (useApproveAgeMax != null) queryParams.useApproveAgeMax = useApproveAgeMax;
  if (areaMin != null) queryParams.areaMin = areaMin;
  if (areaMax != null) queryParams.areaMax = areaMax;
  if (householdMin != null) queryParams.householdMin = householdMin;
  if (householdMax != null) queryParams.householdMax = householdMax;
  if (sigunguGrades != null) queryParams.sigunguGrades = sigunguGrades;
  if (dongGrades != null) queryParams.dongGrades = dongGrades;
  if (houseStructure != null) queryParams.houseStructure = houseStructure;
  // 변동율 필터 파라미터
  if (goHyunRateMin != null) queryParams.goHyunRateMin = goHyunRateMin;
  if (goHyunRateMax != null) queryParams.goHyunRateMax = goHyunRateMax;
  if (jeokHyunRateMin != null) queryParams.jeokHyunRateMin = jeokHyunRateMin;
  if (jeokHyunRateMax != null) queryParams.jeokHyunRateMax = jeokHyunRateMax;
  if (goJeoRateMin != null) queryParams.goJeoRateMin = goJeoRateMin;
  if (goJeoRateMax != null) queryParams.goJeoRateMax = goJeoRateMax;
  if (jeoHyunRateMin != null) queryParams.jeoHyunRateMin = jeoHyunRateMin;
  if (jeoHyunRateMax != null) queryParams.jeoHyunRateMax = jeoHyunRateMax;
  if (changeGapMin != null) queryParams.changeGapMin = changeGapMin;
  if (changeGapMax != null) queryParams.changeGapMax = changeGapMax;
  // 기준가 필터 파라미터
  if (pastTopPriceMin != null) queryParams.pastTopPriceMin = pastTopPriceMin;
  if (pastTopPriceMax != null) queryParams.pastTopPriceMax = pastTopPriceMax;
  if (prevHighPriceMin != null) queryParams.prevHighPriceMin = prevHighPriceMin;
  if (prevHighPriceMax != null) queryParams.prevHighPriceMax = prevHighPriceMax;
  if (properHighPriceMin != null) queryParams.properHighPriceMin = properHighPriceMin;
  if (properHighPriceMax != null) queryParams.properHighPriceMax = properHighPriceMax;
  if (prevLowPriceMin != null) queryParams.prevLowPriceMin = prevLowPriceMin;
  if (prevLowPriceMax != null) queryParams.prevLowPriceMax = prevLowPriceMax;
  // 타겟가 필터 파라미터
  if (targetPriceMin != null) queryParams.targetPriceMin = targetPriceMin;
  if (targetPriceMax != null) queryParams.targetPriceMax = targetPriceMax;
  // 안전마진(개인별) — 값이 있을 때만 전달(없으면 백엔드 기본 0.02 / 0.20)
  if (buyMargin != null) queryParams.buyMargin = buyMargin;
  if (sellMargin != null) queryParams.sellMargin = sellMargin;
  if (houseCount != null) queryParams.houseCount = houseCount;
  if (firstTime != null) queryParams.firstTime = firstTime;

  return get(API_ENDPOINTS.SYSTEM.RANKER_FIX_LIST, queryParams);
};

export const getRankerFixListV2 = async (params = {}) => {
  const {
    bjdCode = '',
    bjdCodes = [],
    keyword = '',
    isFavorite = false,
    highRankerOnly = false,
    gubunFilters = [],
    lastKey = null,
    pageSize = 50,
    sortBy = 'sigungu_grade',
    sortOrder = 'desc',
    useDefaultColumns = true,
    headerFilters = {},
  } = params;

  const bjdCodesCsv = Array.isArray(bjdCodes) ? bjdCodes.join(',') : '';
  const gubunFiltersCsv = Array.isArray(gubunFilters) ? gubunFilters.join(',') : '';
  const headerFiltersJson = Object.keys(headerFilters || {}).length > 0 ? JSON.stringify(headerFilters) : '';

  return get(API_ENDPOINTS.SYSTEM.RANKER_FIX_LIST_V2, {
    bjdCode,
    bjdCodes: bjdCodesCsv,
    keyword,
    isFavorite,
    highRankerOnly,
    gubunFilters: gubunFiltersCsv,
    lastKey,
    pageSize,
    sortBy,
    sortOrder,
    useDefaultColumns,
    headerFilters: headerFiltersJson,
  });
};

export const getRankerGubunCodes = async () => {
  return get(API_ENDPOINTS.SYSTEM.RANKER_GUBUN_CODES);
};

export const getRankerScreenSettings = async () => {
  return get(API_ENDPOINTS.SYSTEM.RANKER_SCREEN_SETTINGS);
};

export const saveRankerScreenSetting = async (payload = {}) => {
  return post(API_ENDPOINTS.SYSTEM.RANKER_SCREEN_SETTINGS_SAVE, payload);
};

export const setDefaultRankerScreenSetting = async (settingId) => {
  return post(API_ENDPOINTS.SYSTEM.RANKER_SCREEN_SETTINGS_DEFAULT, { settingId });
};

export const deleteRankerScreenSetting = async (settingId) => {
  return post(API_ENDPOINTS.SYSTEM.RANKER_SCREEN_SETTINGS_DELETE, { settingId });
};

export const reorderRankerScreenSettings = async (settingIds) => {
  return post(API_ENDPOINTS.SYSTEM.RANKER_SCREEN_SETTINGS_REORDER, { settingIds });
};

// 인자: 숫자(fixId) 또는 { fixId, naverDanjiCode, ptpNo }
// fixId 없으면 백엔드가 단지코드+ptpNo(csv)로 fixId를 찾아 응답
export const getRankerFixArticles = async (arg) => {
  const params = (arg !== null && typeof arg === 'object') ? arg : { fixId: arg };
  const { fixId = null, naverDanjiCode = null, ptpNo = null } = params || {};
  return get(API_ENDPOINTS.SYSTEM.RANKER_FIX_ARTICLES, {
    fixId: fixId || null,
    naverDanjiCode: naverDanjiCode || null,
    ptpNo: ptpNo || null,
  });
};

export const getRankerDanjiDetail = async (naverDanjiCode) => {
  if (!naverDanjiCode) {
    throw new Error('naverDanjiCode는 필수입니다.');
  }

  return get(`${API_ENDPOINTS.SYSTEM.RANKER_DANJI_DETAIL}/${naverDanjiCode}`);
};

// targets: [{ code, ptpNo }] (또는 문자열 코드 배열 — 하위호환)
export const getRankerWeeklyCompare = async (targets = []) => {
  const normalized = (Array.isArray(targets) ? targets : [])
    .map((t) => (typeof t === 'string'
      ? { naverDanjiCode: t.trim(), ptpNo: '' }
      : { naverDanjiCode: String(t?.code || t?.naverDanjiCode || '').trim(), ptpNo: String(t?.ptpNo || '').trim() }))
    .filter((t) => t.naverDanjiCode);

  if (normalized.length === 0) {
    throw new Error('비교 대상(targets)은 필수입니다.');
  }

  return post(API_ENDPOINTS.SYSTEM.RANKER_WEEKLY_COMPARE, {
    targets: normalized,
  });
};

export const getRealTransactions = async (naverDanjiCode, params = {}) => {
  if (!naverDanjiCode) {
    throw new Error('naverDanjiCode는 필수입니다.');
  }

  const {
    pageNumber = 1,
    pageSize = 10,
    periodYears = null,
    ptpNo = null,
    dealType = null,
  } = params;

  return get(`${API_ENDPOINTS.SYSTEM.REAL_TRANSACTIONS}/${naverDanjiCode}`, {
    pageNumber,
    pageSize,
    periodYears,
    ptpNo,
    dealType,
  });
};

export const getRealTransactionsMarket = async (naverDanjiCode, params = {}) => {
  if (!naverDanjiCode) {
    throw new Error('naverDanjiCode는 필수입니다.');
  }

  const {
    pageNumber = 1,
    pageSize = 10,
    periodYears = null,
    ptpNo = null,
    dealType = null,
  } = params;

  return get(`${API_ENDPOINTS.SYSTEM.REAL_TRANSACTIONS_MARKET}/${naverDanjiCode}`, {
    pageNumber,
    pageSize,
    periodYears,
    ptpNo,
    dealType,
  });
};

export const getAskPriceChart = async (naverDanjiCode, params = {}) => {
  if (!naverDanjiCode) {
    throw new Error('naverDanjiCode는 필수입니다.');
  }

  const { ptpNo = null, dealType = null } = params;

  return get(`${API_ENDPOINTS.SYSTEM.ASK_PRICE_CHART}/${naverDanjiCode}`, {
    ptpNo,
    dealType,
  });
};

// 매물호가 + 매물량 통합 차트 (weekly 테이블 기반). dealType(1: 매매, 2: 전세)에 해당하는 값 + 매물량 포함
export const getAskPriceVolumeChart = async (naverDanjiCode, params = {}) => {
  if (!naverDanjiCode) {
    throw new Error('naverDanjiCode는 필수입니다.');
  }

  const { ptpNo = null, dealType = null } = params;

  return get(`${API_ENDPOINTS.SYSTEM.ASK_PRICE_VOLUME_CHART}/${naverDanjiCode}`, {
    ptpNo,
    dealType,
  });
};

export const getWeeklyListingVolume = async (naverDanjiCode, params = {}) => {
  if (!naverDanjiCode) {
    throw new Error('naverDanjiCode는 필수입니다.');
  }

  const {
    periodYears = 3,
    fromDate = null,
    toDate = null,
    ptpNo = null,
  } = params;

  return get(`${API_ENDPOINTS.SYSTEM.WEEKLY_LISTING_VOLUME}/${naverDanjiCode}`, {
    periodYears,
    fromDate,
    toDate,
    ptpNo,
  });
};

export const getRankerScrapingResults = async (params = {}) => {
  const {
    masterId = 10,
    pageNumber = 1,
    pageSize = 50,
  } = params;

  return get(API_ENDPOINTS.SYSTEM.RANKER_SCRAPING_RESULTS, {
    masterId,
    pageNumber,
    pageSize,
  });
};

export const getRankerScrapingMasters = async () => {
  return get(API_ENDPOINTS.SYSTEM.RANKER_SCRAPING_MASTERS);
};

export const getRankingSummary = async (masterId = 10) => {
  return get(API_ENDPOINTS.SYSTEM.RANKING_SUMMARY, { masterId });
};

// 메인 TOP10 랭킹 (지역별 투자금/상승/하락 × 주간·월간·6개월)
// bjdCode: 지역 코드(예: '11'=서울). 미지정 시 백엔드 기본 서울.
export const getTopRankings = async ({ bjdCode = '', limit = 10, investMax = null } = {}) => {
  const params = { bjdCode, limit };
  if (investMax != null) params.investMax = investMax;
  return get(API_ENDPOINTS.SYSTEM.RANKER_TOP_RANKINGS, params);
};

// 핫플(거래량) 지역 TOP — 최근 N개월 실거래건수 많은 구 순
export const getHotPlaces = async ({ bjdCode = '', limit = 10, months = 1 } = {}) => {
  return get(API_ENDPOINTS.SYSTEM.RANKER_HOT_PLACES, { bjdCode, limit, months });
};

// 메인화면설정 조회/저장 (관리자 '메인화면설정')
export const getMainScreenSettings = async () => get(API_ENDPOINTS.SYSTEM.MAIN_SCREEN_SETTINGS);
export const saveMainScreenSettings = async (items) =>
  post(API_ENDPOINTS.SYSTEM.MAIN_SCREEN_SETTINGS_SAVE, { items });
